// Custom event tracking via Plausible Analytics
// Script extensions: tagged-events (CSS class triggers), revenue (payment tracking)
// Goals configured in Plausible dashboard must match event names below.
// Every tracker here has a caller: one without an event in the product (a
// BOM panel, a checkout, store links) sends nothing and only looks wired.

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string | number>; revenue?: { currency: string; amount: number } }) => void;
  }
}

export function trackEvent(name: string, props: Record<string, string | number> = {}) {
  if (window.plausible) {
    window.plausible(name, { props });
  }
}

// --- Auth events ---
export function trackSignup(method = "email") {
  trackEvent("signup", { method });
}

export function trackLogin(method = "email") {
  trackEvent("login", { method });
}

// --- Project events ---
export function trackProjectCreated() {
  trackEvent("project_created");
}

export function trackProjectShared() {
  trackEvent("project_shared");
}

// --- Export events ---
export function trackExportPdf() {
  trackEvent("export_pdf");
}

export function trackExportSvg() {
  trackEvent("export_svg");
}

// --- Waitlist ---
export function trackWaitlistSubscribe(source = "landing") {
  trackEvent("waitlist_subscribe", { source });
}

// --- Marketplace ---
export function trackTemplatePurchase(templateId: number, price: number) {
  const opts = {
    props: { template_id: templateId },
    revenue: { currency: "USD", amount: price }
  };
  if (window.plausible) {
    window.plausible("template_purchase", opts);
  }
}

// --- Blog ---
export function trackArticleRead(slug: string, category: string) {
  trackEvent("article_read", { slug, category });
}

// --- Brand/Product ---
export function trackProductView(product: string, brand: string) {
  trackEvent("product_view", { product, brand });
}

export function trackBrandView(brand: string) {
  trackEvent("brand_view", { brand });
}

// --- AI features ---
export function trackAiAnalysis() {
  trackEvent("ai_analysis");
}

export function trackAiChat() {
  trackEvent("ai_chat");
}

// --- DXF import ---
export function trackDxfImport() {
  trackEvent("dxf_import");
}

// --- Feedback ---
export function trackFeedbackSubmit() {
  trackEvent("feedback_submit");
}
